import React from 'react';
import './ContainedButton.scss';
import {Button} from '../Button';

export class ContainedButton extends Button {

    static defaultProps = {
        className: 'button button-contained button-ripple'
    };
}



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/components/ContainedButton/ContainedButton.jsx